"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = require("./");

exports.default = function (type) {
  return type && [_.DATE_TIME_FIELD, _.NUMBER_FIELD, _.SELECT_FIELD, _.TEXT_FIELD, _.TEXT_AREA_FIELD].includes(type);
};